export default {
  statis() {
    return {
      manuallyHide: false
    }
  },
  methods: {
    onHideModal() {
      if (this.manuallyHide) {
        this.manuallyHide = false
        return
      }
      this.$emit('hide')
    },
    hide() {
      this.manuallyHide = true
      this.$emit('hide')
      this.$refs.modal.hide()
    }
  }
}